import * as yup from 'yup'

const schema = yup.object({
    name: yup
        .string()
        .required('שם המודעה הוא שדה חובה')
        .label('שם'),
    notes: yup
        .string()
        .label('הערות'),
    title: yup
        .string()
        .label('כותרת'),
    caption: yup
        .string()
        .required('טקסט בסרגל הוא שדה חובה')
        .label('טקסט בסרגל'),
    moreInfoText: yup
        .string()
        .label('טקסט חלופי לקישור בסרגל (מידע נוסף)'),
    bodyText: yup
        .string()
        .label('תוכן'),
    conversionButtonText: yup
        .string()
        .label('כיתוב כפתור התגובה'),
    conversionMessage: yup
        .string()
        .label('הודעת אישור לאחר לחיצה'),
    frequency: yup
        .string()
        .oneOf(['oncePerUser', 'everySessionStart'])
        .label('תדירות'),
    startAt: yup
        .string()
        .nullable()
        .label('תחילת תזמון'),
    endAt: yup
        .string()
        .nullable()
        .label('סיום תזמון'),
})

export default schema
